import React from "react";

const SellerPolicy = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "0 auto", lineHeight: "1.6" }}>
      <h1>Onnize Seller Policy Agreement</h1>
      <p><strong>Effective Date:</strong> [Insert Date]</p>

      <h2>1. Purpose and Scope</h2>
      <p>
        This Seller Policy Agreement governs the relationship between Onnize Ltd (“Onnize”)
        and all individuals or entities (“Sellers”) who list, promote, or sell products and
        services through the platform. By using Onnize, the Seller agrees to these terms.
      </p>

      <h2>2. Independent Seller Status</h2>
      <p>
        Sellers operate as independent entities. Nothing in this Agreement creates any
        partnership, agency, or employment relationship. Sellers retain full control over
        pricing, inventory, fulfillment, and customer interactions.
      </p>

      <h2>3. Listings and Product Responsibility</h2>
      <ul>
        <li>All products must be lawful, genuine, and accurately described</li>
        <li>No infringement of intellectual property rights</li>
        <li>Listings must be updated and truthful at all times</li>
      </ul>

      <h2>4. Payments and Financial Responsibility</h2>
      <h3>4.1 No Payment Collection</h3>
      <p>
        Onnize does not collect, process, or hold payments on behalf of Sellers unless
        explicitly agreed in writing.
      </p>

      <h3>4.2 Direct Transactions</h3>
      <p>
        All payments are made directly between Buyers and Sellers. Sellers are fully
        responsible for verifying payments and handling refunds or disputes.
      </p>

      <h3>4.3 No Liability for Non-Payment</h3>
      <p>
        Onnize shall not be held liable for unpaid, partially paid, or fraudulent transactions.
        Sellers assume full risk for payment defaults.
      </p>

      <h2>5. Order Fulfillment and Delivery</h2>
      <h3>5.1 Seller Responsibility</h3>
      <p>
        Sellers are solely responsible for packaging, shipping, and delivering products.
      </p>

      <h3>5.2 No Delivery Obligation</h3>
      <p>
        Onnize does not provide delivery or logistics services unless explicitly stated.
      </p>

      <h3>5.3 No Liability for Delivery Issues</h3>
      <p>
        Onnize is not responsible for any delivery failures, delays, damages, or losses.
        All delivery risks are borne by the Seller.
      </p>

      <h2>6. Buyer-Seller Disputes</h2>
      <p>
        Onnize may offer limited mediation at its discretion but is not obligated to resolve
        disputes. Responsibility remains between Buyer and Seller.
      </p>

      <h2>7. Compliance</h2>
      <p>
        Sellers must comply with all applicable laws, including tax and consumer protection
        regulations. Sellers are responsible for licenses, permits, and legal obligations.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        Onnize shall not be liable for indirect, incidental, or consequential damages including
        loss of revenue, profits, or business interruption.
      </p>

      <h2>9. Indemnification</h2>
      <p>
        Sellers agree to indemnify and hold Onnize harmless from any claims arising from their
        operations, legal violations, or disputes with customers.
      </p>

      <h2>10. Suspension and Termination</h2>
      <p>
        Onnize reserves the right to suspend or terminate accounts at its discretion, especially
        in cases of fraud, policy violations, or legal risks.
      </p>

      <h2>11. Amendments</h2>
      <p>
        Onnize may update this Agreement at any time. Continued use of the platform constitutes
        acceptance of updated terms.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        This Agreement shall be governed by applicable laws in the jurisdiction where Onnize
        operates.
      </p>

      <h2>13. Acceptance</h2>
      <p>
        By using the platform, the Seller confirms that they have read, understood, and agreed
        to this policy.
      </p>
    </div>
  );
};

export default SellerPolicy;